import type { UserService } from '../../user'
import type { GeoLocationService } from '../../geo-location'
import type { BrowserService } from '../../browser'
import { Experiment } from '@grammarly/experimentation-js-sdk'
import { clientExperimentsConfig } from './client-experiments'

export interface ExperimentContext {
  userService: UserService
  geoLocationService: GeoLocationService
  browserService: BrowserService
  pageSlug: string
}

export type ClientExperimentConfig = {
  experimentId: string
  variants: readonly string[]
  eligibility: (ctx: ExperimentContext) => boolean
}

function createClientExperiments<T extends Record<string, ClientExperimentConfig>>(config: T) {
  const experiments: Record<string, Experiment> = {}
  const eligibilityFns: Record<string, (ctx: ExperimentContext) => boolean> = {}

  for (const key in config) {
    const { experimentId, variants, eligibility } = config[key]
    experiments[key] = new Experiment(experimentId, [...variants])
    eligibilityFns[key] = eligibility
  }

  return {
    experiments: experiments as {
      [K in keyof T]: Experiment<T[K]['variants'][number]>
    },
    eligibility: eligibilityFns as {
      [K in keyof T]: T[K]['eligibility']
    },
  }
}

const clientExperiments = createClientExperiments(clientExperimentsConfig)

export const ClientAssignedExperiments = clientExperiments.experiments
export const ClientExperimentEligibility = clientExperiments.eligibility
